"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDefault = useDefault;
require("core-js/modules/es.array.concat.js");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var noop = function noop() {};
function useDefault(value, defaultValue, onChange) {
  var isControlledRef = (0, _react.useRef)(false);
  var _useState = (0, _react.useState)(defaultValue),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    internalValue = _useState2[0],
    setInternalValue = _useState2[1];

  // 受控模式
  if (isControlledRef.current || typeof value !== 'undefined') {
    isControlledRef.current = true;
    return [value, onChange || noop];
  }

  // 非受控模式
  return [internalValue, function (newValue) {
    setInternalValue(newValue);
    if (typeof onChange === 'function') {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      onChange.apply(void 0, [newValue].concat(args));
    }
  }];
}